import { Outlet } from "react-router-dom";
import Footer from "../Footer";
import Navbar from "../Navbar";
import useGTMTracker from "../../hooks/useGTMTracker";

const DefaultLayout = () => {
  useGTMTracker();

  return (
    <>
      <main className="min-h-screen w-screen grid grid-rows-[auto_1fr_auto] relative overflow-x-hidden">
        <Navbar />
        <div className="pb-6 lg:pb-10">
          <Outlet />
        </div>
        <Footer />
      </main>
    </>
  );
};

export default DefaultLayout;
